var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _vm.visible
        ? _c(
            "b-tab",
            {
              staticClass: "custom-tab-item",
              attrs: {
                active: _vm.active,
                lazy: _vm.lazy,
                tabindex: _vm.tabindex,
                tag: "div",
                "title-item-class": _vm.navItemClass,
                "title-link-class": _vm.navLinkClass
              },
              on: {
                click: function($event) {
                  return _vm.$emit("click", $event)
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex text-center justify-content-center"
                          },
                          [
                            _c("div", { class: _vm.hasError && "mr-2" }, [
                              _vm._v(" " + _vm._s(_vm.title) + " ")
                            ]),
                            _vm.hasError
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center align-items-center title-tab-wrapper"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fas fa-exclamation-triangle text-danger error-icon",
                                      class: _vm.active && "txt-white"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                366968017
              )
            },
            [_vm._t("default")],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }